import React, { useEffect, useState } from "react";
import TopViewNav from "../CommonComponents/TopViewNav";
import {
  Box,
  Checkbox,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { SummaryAction } from "../../actions/summary";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import RestoreIcon from "@mui/icons-material/Restore";
import { useNavigate } from "react-router-dom";
import ApproverCompanyPermissionModule from "./ApproverCompanyPermissionModule";
import "./odRestoreEmployee.css";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import CustomButton from "../CommonComponents/Button";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { UserIdApprover } from "../../actions/Approver";
import { CompanyAndUsersData } from "../../actions/CompanyAndUsers";
import LoadingComponent from "../CommonComponents/LoadingComponent";

const OD_RESTORE_FE_CONFIG_KEY = "odRestore";
const DEVICE_RESTORE_FE_CONFIG_KEY = "deviceRestore";
const APPROVER_FE_CONFIG_KEY = "expenseApprover";

const initialConfigurations = [
  {
    key: APPROVER_FE_CONFIG_KEY,
    name: "Expense Approver",
    allowedToShow: true,
  },
  {
    key: OD_RESTORE_FE_CONFIG_KEY,
    name: "OD Restore",
    allowedToShow: false,
  },
  {
    key: DEVICE_RESTORE_FE_CONFIG_KEY,
    name: "Device Restore",
    allowedToShow: false,
  },
];

const getTooltip = (key, name) => {
  switch (key) {
    case OD_RESTORE_FE_CONFIG_KEY:
      return `Restore OD for ${name}`;
    case DEVICE_RESTORE_FE_CONFIG_KEY:
      return `Restore Device for ${name}`;
    case APPROVER_FE_CONFIG_KEY:
      return `Approve Expense for ${name}`;
    default:
      return "";
  }
};

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#fff",
  "& .MuiInputBase-root": {
    width: "100% !important",
    "& .MuiInputBase-input": {
      height: "18.25px",
      width: "100% !important",
    },
  },

  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  "& .MuiInputBase-root": {
    width: "100% !important",
    "& .MuiInputBase-input": {
      width: "100% !important",
    },
  },
}));

const getDynamicGridSize = ({
  index,
  activeKey,
  // isSiteConfigEnabled
}) => {
  const isSiteConfigEnabled = false;
  if (index === 0) {
    return {
      xs: 12,
      sm: 6,
      md: 4.5,
      lg: 3,
    };
  } else if (index === 5) {
    if (isSiteConfigEnabled) {
      return {
        xs: 12,
        lg: 2.25,
      };
    }
    return {
      xs: 12,
      sm: 6,
      md: 12,
      lg: 3,
    };
  } else if (
    [OD_RESTORE_FE_CONFIG_KEY, DEVICE_RESTORE_FE_CONFIG_KEY].includes(activeKey)
  ) {
    return {
      xs: 12,
      sm: 6,
      md: 3,
      lg: 2,
    };
  } else if (activeKey === APPROVER_FE_CONFIG_KEY) {
    if (isSiteConfigEnabled) {
      return {
        xs: 12,
        sm: 6,
        md: 2.5,
        lg: 2.25,
      };
    }
    return {
      xs: 12,
      sm: 6,
      md: 3.75,
      lg: 3,
    };
  }
  return {
    xs: 12,
    sm: 6,
    md: 3,
    lg: 2,
  };
};

const isFinalToShow = (
  itemKey,
  viewingDeviceRestore,
  // localData
) => {
  const localData = { isSiteConfigEnabled: false };

  const activeKey = viewingDeviceRestore?.key;
  const isSiteEnabled = localData?.isSiteConfigEnabled;
  if (activeKey === APPROVER_FE_CONFIG_KEY && itemKey === "site") {
    return Boolean(isSiteEnabled);
  }
  if (
    itemKey === "default" &&
    [OD_RESTORE_FE_CONFIG_KEY, DEVICE_RESTORE_FE_CONFIG_KEY].includes(activeKey)
  ) {
    return true;
  }

  return itemKey === activeKey;
};

const OdRestoreEmployee = () => {
  const navigate = useNavigate();
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  const [configurations, setConfigurations] = useState([
    ...initialConfigurations,
  ]);
  console.log("configurations : ", configurations);
  const [viewingDeviceRestore, setViewingDeviceRestore] = useState(null);
  console.log("viewingDeviceRestore : ", viewingDeviceRestore);
  const topViewNavData = {
    // title: viewingDeviceRestore ? "Device Restore" : "OD Restore",
    title: "Configuration",
    backPathRoute: "/dashboard",
  };
  const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [singleDeviceLoginPermission, setSingleDeviceLoginPermission] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // EXPEMSE APPROVER VALUES PLAYGROUND STARTS
  const [siteList, setSiteList] = useState([]);
  const [siteId, setSiteId] = useState();
  const [companyUsers, setCompanyUsers] = useState([]);
  console.log("companyUsers: ", companyUsers);
  const [companyId, setCompanyId] = useState({
    id: localData?.hrmsCompanyId,
    companyName: localData?.companyName,
    isSiteConfigEnabled: localData?.isSiteConfigEnabled,
    totalNoUser: 0,
    userDtoList: [],
  });
  console.log("companyId : ", companyId);
  const [oldUsers, setOldUsers] = useState([]);
  console.log("oldUsers: ", oldUsers);
  const [companyUseId, setcompanyUseId] = useState([]);
  console.log("companyUseId: ", companyUseId);
  const [approveUserId, setApproveUserId] = useState(null);
  const [approverlist, setApproverlist] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isRestrictedToEndUser, setIsRestrictedToEndUser] = useState(false);
  const [duplicateUsers, setDuplicateUsers] = useState([]);

  const selectAllOption = { id: "selectAll", name: "Select All", empCode: "" };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  let oldusr = [];
  let uId = [];
  // EXPEMSE APPROVER VALUES PLAYGROUND ENDS

  const fetchClientBaseEmpForUsers = () => {
    const companyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    const data = {
      companyId: companyId ? companyId : null,
    };
    companyWiseEmp.fetchCompnyWiseUpdate(data).then((response) => {
      if (response !== null && response.responseCode === 200) {
        const hasSingleDeviceLoginPermission =
          response.data &&
          response.data.filter(
            (val) =>
              val.hrmsConfigurationName === "SINGLE_DEVICE_LOGIN_PERMISSION",
          );
        const permit =
          hasSingleDeviceLoginPermission &&
          hasSingleDeviceLoginPermission.length > 0
            ? hasSingleDeviceLoginPermission[0].isEnable === true
              ? true
              : false
            : false;
        setSingleDeviceLoginPermission(permit);
      }
    });
  };

  const fetchOwnerList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    const data = {
      hrmsUserId: hrmsID && hrmsID,
      userId: JSON.parse(localStorage.getItem("data")).id,
      siteId: JSON.parse(localStorage.getItem("data")).isSiteConfigEnabled
        ? JSON.parse(localStorage.getItem("data")).siteId
        : null,
    };
    const res = await SummaryAction.FetchUserList(data);
    if (res !== null) {
      console.log(res);
      setUserList(res.data);
    } else {
      setUserList([]);
    }
  };

  const filteredUsers = userList.filter((user) => {
    const search = searchText.toLowerCase();

    return (
      user?.name?.toLowerCase().includes(search) ||
      user?.empCode?.toLowerCase().includes(search)
    );
  });

  const RestoreOd = (userId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to restore OD for this employee?",
    );

    if (!isConfirmed) return;

    const payload = { userId };

    companyWiseEmp
      .restoreOdForEmployee(payload)
      .then((response) => {
        console.log("API response:", response);

        if (typeof response === "string") {
          alert(response);
        } else {
          alert("OD restored successfully");
        }
      })
      .catch((error) => {
        console.error(error);
        alert("Something went wrong while restoring OD");
      });
  };

  const restoreDeviceForUser = async (userId) => {
    if (!Boolean(userId)) {
      alert("Please select an user first");
      return;
    }
    if (
      window.confirm(
        "Are you sure you want to restore Device for this employee?",
      )
    ) {
      const response = await companyWiseEmp.fetchRestoreDeviceForUser({
        userId,
      });
      if (response && response?.status === 200) {
        alert(response?.data || "Device restored successfully");
      } else {
        const parsedErrMessage =
          response?.response?.data ||
          response?.message ||
          "Something went wrong while restoring Device";
        alert(parsedErrMessage);
      }
    }
  };

  const checkPermission = () => {
    const data = JSON.parse(localStorage.getItem("data"));

    // if (!data?.hasPermissionToRestoreOd) {
    //   navigate("/login");
    // }
    if (!data?.isCompanyConfigurationPermissionEnable) {
      navigate("/login");
    }
    // if (!data?.hasPermissionToRestoreOd) {
    //   setTimeout(() => {
    //     navigate("/login");
    //   }, 2000);
    // }
  };

  const handleToggleViewOdDeviceRestore = (val) => {
    setViewingDeviceRestore(val);
  };

  const handleAction = (key, userId) => {
    switch (key) {
      case OD_RESTORE_FE_CONFIG_KEY:
        return RestoreOd(userId);
      case DEVICE_RESTORE_FE_CONFIG_KEY:
        return restoreDeviceForUser(userId);
      default:
        return;
    }
  };

  // EXPEMSE APPROVER FUNCTIONS PLAYGROUND STARTS
  const siteListHandle = (value) => {
    if (value) {
      setCompanyUsers(
        (Array.isArray(companyId?.userDtoList)
          ? companyId?.userDtoList
          : []
        )?.filter((item) => item?.siteId === value?.id),
      );
      setOldUsers([]);
      setSiteId(value);
    } else {
      setCompanyUsers(
        Array.isArray(companyId?.userDtoList) ? companyId?.userDtoList : [],
      );
      setOldUsers([]);
      setSiteId(null);
    }
  };

  const handleSetSiteAndUsers = ({ users = [] }) => {
    const siteId = JSON.parse(localStorage.getItem("data")).isSiteConfigEnabled
      ? JSON.parse(localStorage.getItem("data")).siteId
      : null;

    const finalUsers = users?.map((item) => ({ ...item, id: item?.userId }));
    setCompanyUsers([...finalUsers]);
    setOldUsers([]);
    if (siteId) {
      setSiteId({ id: siteId });
    } else {
      setSiteId(null);
    }
  };
  const companyUserListHandle = (value) => {
    console.log("value: ", value);
    if (value?.some((val) => val?.id === "selectAll")) {
      console.log(value, "hdvwhdew");
      // const filteredCompanyUsers = companyUsers?.filter(
      //   (user) => !user?.isApproverSet
      // );

      if (
        Boolean(companyUseId?.length > 0) &&
        Boolean(companyUseId?.length === companyUsers?.length)
      ) {
        oldusr = [];
        setcompanyUseId([]);
        setOldUsers(companyUsers);
      } else {
        // const filteredCompanyUsersIsApproverSetTrue = companyUsers?.filter(
        //   (user) => user?.isApproverSet
        // );
        // oldusr = filteredCompanyUsersIsApproverSetTrue;
        oldusr = [];
        console.log("oldusr: ", oldusr);

        // setOldUsers(filteredCompanyUsersIsApproverSetTrue);
        setOldUsers([]);
        // for (let i = 0; i < value.length; i++) {
        //   uId.push(value[i].id);
        // }
        companyUsers?.map((item) => {
          uId.push(item?.id);
        });
        console.log(uId);
        setcompanyUseId(uId);
      }
    } else {
      console.log(value, "hdvwhdew");
      oldusr.push(value);
      console.log("oldusr: ", oldusr);
      // if (value !== null) {

      // }
      // else {

      // }
      //   console.log(value);
      const uniqueOnject = companyUsers.filter(
        ({ id: id1 }) => !value.some(({ id: id2 }) => id1 === id2),
      );
      setOldUsers(uniqueOnject);
      for (let i = 0; i < value.length; i++) {
        uId.push(value[i].id);
      }
      console.log(uId);
      setcompanyUseId(uId);
    }
  };
  const approveUserHandle = (value) => {
    if (value !== null) {
      setApproveUserId(value.id);
    } else {
      setApproveUserId("");
    }
  };
  const fetchMultiLevelApproverListForCompanyDetails = async () => {
    const siteIdFromLocal = JSON.parse(localStorage.getItem("data"))
      .isSiteConfigEnabled
      ? JSON.parse(localStorage.getItem("data")).siteId
      : null;
    if (companyId?.isSiteConfigEnabled && !siteId && false) {
      return alert("Please Select Site!");
    }
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    let data = {
      hrmsCompanyId: companyId ? companyId.id : hrmsCompanyId || null,
      userIds: companyUseId,
      approverId: approveUserId,
      siteId: siteId?.id || siteIdFromLocal || null,
      userId: localData?.id,
      hrmsUserId: localData?.hrmsUserId,
    };

    const res =
      await UserIdApprover.fetchMultiLevelApproverListForEndUser(data);
    if (res !== null) {
      console.log(res);

      console.log("multi level approver list: ", res);
      setApproverlist(res.data);
    } else {
      setApproverlist([]);
    }
  };
  const openModalHandler = () => {
    setOpenModal(true);
    setIsRestrictedToEndUser(true);
  };
  const updateHandler = () => {
    if (companyId === undefined || companyId === "") {
      alert("plz Select company Name ");
      return false;
    }
    const data = {
      companyId: companyId ? companyId.id : null,
      hrmsUserIds: [],
    };

    CompanyAndUsersData.fetchCompanyUpdateByID(data).then((response) => {
      if (response !== null) {
        alert("Update Successfully!!");
      }
    });
  };
  const checkForDuplicateUsers = (selectedUserIds) => {
    if (!selectedUserIds?.length || !approverlist?.length) {
      setDuplicateUsers([]);
      return;
    }

    const configuredUserIds = approverlist.map((item) => item?.user?.id);

    const duplicates = companyUsers.filter(
      (user) =>
        selectedUserIds.includes(user.id) &&
        configuredUserIds.includes(user.id),
    );

    setDuplicateUsers(duplicates);
  };

  // EXPEMSE APPROVER FUNCTIONS PLAYGROUND ENDS

  useEffect(() => {
    setConfigurations((prev) => {
      return prev?.map((item) => {
        if (
          [OD_RESTORE_FE_CONFIG_KEY, DEVICE_RESTORE_FE_CONFIG_KEY].includes(
            item?.key,
          )
        ) {
          return {
            ...item,
            allowedToShow: localData?.isOdDeviceRestorePermissionEnable,
          };
        } else if ([APPROVER_FE_CONFIG_KEY].includes(item?.key)) {
          return {
            ...item,
            allowedToShow: localData?.isExpenseApprovePermissionEnable,
          };
        } else {
          return item;
        }
      });
    });
  }, []);

  useEffect(() => {
    checkPermission();
    fetchOwnerList();
    fetchClientBaseEmpForUsers();
  }, []);

  useEffect(() => {
    if (configurations?.length) {
      const firstAllowed = configurations.find((item) => item?.allowedToShow);

      setViewingDeviceRestore(firstAllowed || null);
    }
  }, [configurations]);

  // EXPEMSE APPROVER EFFECTS PLAYGROUND STARTS
  useEffect(() => {
    if (Boolean(userList?.length > 0)) {
      setCompanyId((prev) => ({ ...prev, userDtoList: [...userList] }));
      handleSetSiteAndUsers({ users: [...userList] });
    }
  }, [userList]);

  useEffect(() => {
    const holdApproverAtOdRestoreEmployee =
      JSON.parse(localStorage.getItem("holdApproverAtOdRestoreEmployee")) ||
      false;
    if (holdApproverAtOdRestoreEmployee) {
      handleToggleViewOdDeviceRestore(configurations[0]);
      localStorage.removeItem("holdApproverAtOdRestoreEmployee");
    }
  }, []);
  useEffect(() => {
    if (isRestrictedToEndUser) {
      checkForDuplicateUsers(companyUseId);
    }
  }, [companyUseId, isRestrictedToEndUser]);

  // EXPEMSE APPROVER EFFECTS PLAYGROUND ENDS

  return (
    <div>
      <main className="contents__root">
        <LoadingComponent isLoading={isLoading} />
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "end",
                justifyContent: "space-between",
                // border: "1px solid black",
              }}
            >
              <TopViewNav
                topViewNavData={topViewNavData}
                // clientSatatusBtn={
                //   companyIdByBtn && companyIdByBtn ? true : false
                // }
                // openDyanamiceForm={openDyanamiceForm}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={0.5}>
              <Grid
                item
                {...getDynamicGridSize({
                  index: 0,
                  activeKey: viewingDeviceRestore?.key,
                  isSiteConfigEnabled: localData?.isSiteConfigEnabled,
                })}
              >
                {configurations?.some((item) => item?.allowedToShow) ? (
                  <div className="field_box field_toggle override_toggle">
                    {configurations
                      ?.filter((item) => item?.allowedToShow)
                      ?.map((config, index) => (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {index !== 0 && (
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{
                                borderColor: "#2a3478",
                                borderRightWidth: "1px",
                              }}
                            />
                          )}

                          <div
                            key={config?.key}
                            className={
                              viewingDeviceRestore?.key === config?.key
                                ? "active"
                                : ""
                            }
                            onClick={() =>
                              handleToggleViewOdDeviceRestore(config)
                            }
                          >
                            {config?.name}
                          </div>
                        </Box>
                      ))}
                  </div>
                ) : (
                  ""
                )}
              </Grid>

              {isFinalToShow("default", viewingDeviceRestore, localData) ? (
                <Grid
                  item
                  {...getDynamicGridSize({
                    index: 1,
                    activeKey: viewingDeviceRestore?.key,
                    isSiteConfigEnabled: localData?.isSiteConfigEnabled,
                  })}
                >
                  <div
                    className="field_box search_box"
                    style={{ alignItems: "inherit" }}
                  >
                    <Search>
                      <StyledInputBase
                        placeholder="Search ..."
                        inputProps={{ "aria-label": "search" }}
                        required
                        id="outlined-basic"
                        label="JSON Key "
                        name="key"
                        variant="outlined"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </Search>
                  </div>
                </Grid>
              ) : (
                ""
              )}

              {isFinalToShow("site", viewingDeviceRestore, localData) ? (
                <Grid
                  item
                  {...getDynamicGridSize({
                    index: 2,
                    activeKey: viewingDeviceRestore?.key,
                    isSiteConfigEnabled: localData?.isSiteConfigEnabled,
                  })}
                >
                  <CustomAutoComplete
                    disablePortal
                    id="company"
                    value={siteId || null}
                    options={(siteList !== undefined && siteList) || []}
                    getOptionLabel={(option) => option.name}
                    sx={{ width: "auto" }}
                    onChange={(event, newValue) => siteListHandle(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Site" />
                    )}
                    size="small"
                  />
                </Grid>
              ) : (
                ""
              )}

              {isFinalToShow(
                APPROVER_FE_CONFIG_KEY,
                viewingDeviceRestore,
                localData,
              ) ? (
                <Grid
                  item
                  {...getDynamicGridSize({
                    index: 3,
                    activeKey: viewingDeviceRestore?.key,
                    isSiteConfigEnabled: localData?.isSiteConfigEnabled,
                  })}
                >
                  <CustomAutoComplete
                    disablePortal
                    disableCloseOnSelect
                    limitTags={3}
                    id="user"
                    multiple
                    disabled={
                      companyUsers && companyUsers.length > 0 ? false : true
                    }
                    // options={companyUsers && companyUsers === [] ? [] : companyUsers}
                    options={
                      Array.isArray(companyUsers) &&
                      Boolean(companyUsers?.length)
                        ? // ? companyUsers
                          [selectAllOption, ...companyUsers]
                        : []
                    }
                    // getOptionDisabled={(option) => option?.isApproverSet === true}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      // const filteredCompanyUsers = companyUsers?.filter(
                      //   (user) => !user?.isApproverSet
                      // );
                      const isSelectAll = option?.empCode === "";
                      const isAllSelected =
                        Boolean(companyUseId?.length > 0) &&
                        Boolean(companyUseId?.length === companyUsers?.length);
                      if (Boolean(option?.empCode === "")) {
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={isSelectAll ? isAllSelected : selected}
                            />
                            {Boolean(option?.empCode === "")
                              ? `${option?.name}`
                              : `${option?.name} (${option?.empCode})`}
                          </li>
                        );
                      }
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {Boolean(option?.empCode === "")
                            ? `${option?.name}`
                            : `${option?.name} (${option?.empCode})`}
                        </li>
                      );
                    }}
                    value={companyUsers.filter((item) =>
                      companyUseId.includes(item?.id),
                    )}
                    onChange={(value, newVal) => companyUserListHandle(newVal)}
                    getOptionLabel={({ name, empCode, id }) => {
                      if (Boolean(empCode === "")) {
                        return `${name}`;
                      }
                      return `${name} (${empCode})`;
                    }}
                    sx={{ width: "auto" }}
                    renderInput={(params) => (
                      <TextField {...params} label="Company Users" />
                    )}
                    size="small"
                  />
                  {/* <MultiSelectField sx={{ width: "100%" }} size="small">
            <InputLabel id="demo-multiple-checkbox-label">User</InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={personName}
              onChange={handleChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {names.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={personName.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </MultiSelectField> */}
                </Grid>
              ) : (
                ""
              )}

              {isFinalToShow(
                APPROVER_FE_CONFIG_KEY,
                viewingDeviceRestore,
                localData,
              ) ? (
                <Grid
                  item
                  {...getDynamicGridSize({
                    index: 4,
                    activeKey: viewingDeviceRestore?.key,
                    isSiteConfigEnabled: localData?.isSiteConfigEnabled,
                  })}
                >
                  <CustomAutoComplete
                    disablePortal
                    id="user"
                    disabled={oldUsers && oldUsers.length > 0 ? false : true}
                    options={oldUsers && oldUsers.length === 0 ? [] : oldUsers}
                    // getOptionLabel={(option) => option.name}
                    getOptionLabel={({ name, empCode }) => {
                      return `${name} (${empCode})`;
                    }}
                    onChange={(value, newVal) => approveUserHandle(newVal)}
                    sx={{ width: "auto" }}
                    renderInput={(params) => (
                      <TextField {...params} label="Approver" />
                    )}
                    size="small"
                  />
                </Grid>
              ) : (
                ""
              )}

              {isFinalToShow(
                APPROVER_FE_CONFIG_KEY,
                viewingDeviceRestore,
                localData,
              ) ? (
                <Grid
                  item
                  {...getDynamicGridSize({
                    index: 5,
                    activeKey: viewingDeviceRestore?.key,
                    isSiteConfigEnabled: localData?.isSiteConfigEnabled,
                  })}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      columnGap: 2,
                    }}
                  >
                    <CustomButton
                      name={"Submit"}
                      // onClick={fetchApproverList}
                      onClick={() =>
                        fetchMultiLevelApproverListForCompanyDetails()
                      }
                    />

                    <CustomButton
                      name={"Add"}
                      onClick={() => openModalHandler()}
                    ></CustomButton>

                    <CustomButton
                      name={"Update "}
                      onClick={() => updateHandler()}
                    ></CustomButton>
                  </Box>
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ px: 1 }}>
              <Grid
                container
                direction="row"
                alignItems="center"
                sx={{ mt: 0.2 }}
              >
                {[
                  OD_RESTORE_FE_CONFIG_KEY,
                  DEVICE_RESTORE_FE_CONFIG_KEY,
                ]?.includes(viewingDeviceRestore?.key) ? (
                  <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                      <TableHead
                        style={{ color: "#fff", backgroundColor: "#32577e" }}
                      >
                        <TableCell className="tabalecellStyle" align="center">
                          <Typography sx={{ fontSize: "14px" }}>
                            S.no
                          </Typography>
                        </TableCell>
                        <TableCell className="tabalecellStyle" align="center">
                          <Typography sx={{ fontSize: "14px" }}>
                            Employee Name
                          </Typography>
                        </TableCell>

                        <TableCell className="tabalecellStyle" align="center">
                          <Typography sx={{ fontSize: "14px" }}>
                            Action
                          </Typography>
                        </TableCell>
                      </TableHead>
                      <TableBody>
                        {
                          // userList &&
                          filteredUsers?.map((val, ind) => {
                            return (
                              <>
                                <TableRow>
                                  <TableCell align="center">
                                    {ind + 1}
                                  </TableCell>
                                  <TableCell align="center">
                                    {val?.name}({val?.empCode})
                                  </TableCell>
                                  {/* <TableCell></TableCell> */}
                                  <TableCell align="center">
                                    {/* <div className="field_box">
                                    <div
                                      className="field_box_btn1"
                                      //   onClick={RestoreOd}
                                      onClick={() => RestoreOd(val?.userId)}
                                      style={{
                                        cursor: "pointer",
                                        width: "60px",
                                      }}
                                    >
                                      Restore
                                    </div>
                                  </div> */}
                                    <Tooltip
                                      title={getTooltip(
                                        viewingDeviceRestore?.key,
                                        val?.name,
                                      )}
                                    >
                                      <IconButton
                                        // onClick={() => {
                                        //   if (viewingDeviceRestore) {
                                        //     restoreDeviceForUser(val?.userId);
                                        //   } else {
                                        //     RestoreOd(val?.userId);
                                        //   }
                                        // }}
                                        onClick={() =>
                                          handleAction(
                                            viewingDeviceRestore?.key,
                                            val?.userId,
                                          )
                                        }
                                      >
                                        <RestoreIcon
                                          sx={{ color: "#32577E" }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          })
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  ""
                )}
                {viewingDeviceRestore?.key === APPROVER_FE_CONFIG_KEY ? (
                  <ApproverCompanyPermissionModule
                    oldusr={oldusr}
                    companyId={companyId}
                    setCompanyId={setCompanyId}
                    setCompanyUsers={setCompanyUsers}
                    setOldUsers={setOldUsers}
                    setSiteList={setSiteList}
                    siteId={siteId}
                    setSiteId={setSiteId}
                    companyUseId={companyUseId}
                    approveUserId={approveUserId}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    approverlist={approverlist}
                    setApproverlist={setApproverlist}
                    fetchMultiLevelApproverListForCompanyDetails={
                      fetchMultiLevelApproverListForCompanyDetails
                    }
                    companyUserListHandle={companyUserListHandle}
                    companyUsers={companyUsers}
                    oldUsers={oldUsers}
                    approveUserHandle={approveUserHandle}
                    siteList={siteList}
                    siteListHandle={siteListHandle}
                    isRestrictedToEndUser={isRestrictedToEndUser}
                    setIsRestrictedToEndUser={setIsRestrictedToEndUser}
                    duplicateUsers={duplicateUsers}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default OdRestoreEmployee;
